const customListItems = [
  // UL ここから
  {
    label: '箇条書きLv1',
    labelStyle: 'color: red',
    className: 'bullet_1',
    type: 'ul',
    canSetNumber: false,
    order: 100,
  },
  {
    label: '箇条書きLv1テキスト',
    labelStyle: 'color: red',
    className: 'bullet_1_text',
    type: 'ul',
    canSetNumber: false,
    order: 200,
  },
  {
    label: '箇条書きLv2',
    labelStyle: 'color: green',
    className: 'bullet_2',
    type: 'ul',
    canSetNumber: false,
    order: 300,
  },
  {
    label: '箇条書きLv2テキスト',
    labelStyle: 'color: green',
    className: 'bullet_2_text',
    type: 'ul',
    canSetNumber: false,
    order: 400,
  },
  {
    label: '補足注釈Lv1',
    labelStyle: 'color: blue',
    className: 'arrows_1',
    type: 'ul',
    canSetNumber: false,
    order: 500,
  },
  {
    label: '補足注釈Lv2',
    labelStyle: 'color: blue',
    className: 'arrows_2',
    type: 'ul',
    canSetNumber: false,
    order: 600,
  },
  {
    label: '注釈Lv1',
    labelStyle: 'color: purple',
    className: 'remarks_1',
    type: 'ul',
    canSetNumber: false,
    order: 700,
  },
  {
    label: '注釈Lv2',
    labelStyle: 'color: purple',
    className: 'remarks_2',
    type: 'ul',
    canSetNumber: false,
    order: 700,
  },
  /*
  *orias‑188によりコメントアウト
  {
    label: 'WarningList',
    labelStyle: 'color: hotpink',
    className: 'warning_list',
    type: 'ul',
    canSetNumber: false,
    order: 1000,
  },
  */
  // UL ここまで
  // OL ここから
  {
    label: '手順型本文1',
    labelStyle: 'color: red',
    className: 'procedure_1',
    type: 'ol',
    canSetNumber: false,
    order: 100,
  },
  {
    label: '手順型本文N',
    labelStyle: 'color: red',
    className: 'procedure_n',
    type: 'ol',
    canSetNumber: true,
    order: 200,
  },
  {
    label: '手順型本文テキスト',
    labelStyle: 'color: red',
    className: 'procedure_text',
    type: 'ol',
    canSetNumber: false,
    order: 300,
  },
  {
    label: '白抜き丸数字1',
    labelStyle: 'color: green',
    className: 'callout_1',
    type: 'ol',
    canSetNumber: false,
    order: 400,
  },
  {
    label: '白抜き丸数字N',
    labelStyle: 'color: green',
    className: 'callout_n',
    type: 'ol',
    canSetNumber: true,
    order: 500,
  },
  {
    label: '白抜き丸数字テキスト',
    labelStyle: 'color: green',
    className: 'callout_text',
    type: 'ol',
    canSetNumber: false,
    order: 600,
  },
  {
    label: '白抜き丸数字横1',
    labelStyle: 'color: blue',
    className: 'callout_h_1',
    type: 'ol',
    canSetNumber: false,
    order: 700,
  },
  {
    label: '白抜き丸数字横N',
    labelStyle: 'color: blue',
    className: 'callout_h_n',
    type: 'ol',
    canSetNumber: true,
    order: 800,
  },
  /*orias‑287によりコメントアウト
  {
    label: '白抜き丸数字横',
    labelStyle: 'color: blue',
    className: 'callout_h_text',
    type: 'ol',
    canSetNumber: false,
    order: 900,
  },
  */
  {
    label: '注釈1',
    labelStyle: 'color: purple',
    className: 'procedure_remarks_1',
    type: 'ol',
    canSetNumber: false,
    order: 1000,
  },
  {
    label: '注釈N',
    labelStyle: 'color: purple',
    className: 'procedure_remarks_n',
    type: 'ol',
    canSetNumber: true,
    order: 1100,
  },
  {
    label: '注釈テキスト',
    labelStyle: 'color: purple',
    className: 'procedure_remarks_text',
    type: 'ol',
    canSetNumber: false,
    order: 1200,
  },
  // OL ここまで
];

export default customListItems;
